import { render, staticRenderFns } from "./EndorsementHistoryDetail.vue?vue&type=template&id=35714742"
import script from "./EndorsementHistoryDetail.vue?vue&type=script&lang=js"
export * from "./EndorsementHistoryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports